import type { ReactNode } from 'react';
import { clsx } from '../../ds/clsx';
import styles from './AuthFrame.module.css';

/** Frame shared by login, 2FA, lockout and password reset (Shell 16–19): wordmark, card column, footer. */
export function AuthFrame({ children, wide = false }: { children: ReactNode; wide?: boolean | undefined }) {
  return (
    <div className={styles.frame}>
      <div className={styles.wordmark}>DAMOKLES</div>
      <div className={clsx(styles.column, wide && styles.columnWide)}>{children}</div>
      <div className={styles.footer}>
        <a
          className={styles.footerLink}
          href="https://paulgoestl.de/impressum"
          target="_blank"
          rel="noreferrer"
        >
          Impressum
        </a>
        <a
          className={styles.footerLink}
          href="https://paulgoestl.de/datenschutz"
          target="_blank"
          rel="noreferrer"
        >
          Datenschutz
        </a>
        <span>{window.location.host}</span>
      </div>
    </div>
  );
}
